<template>
  <v-container>

    <v-layout wrap>
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-form ref="titleForm" lazy-validation @submit='onSubmitPrevent' onSubmit="return false;">
              <v-text-field 
                :counter="100" 
                label="What are you asking about" 
                placeholder="event RSVP, signup sheet, other"
                data-vv-name="title" 
                v-model="formTitle"
                :rules="[rules.required]"
                ref="title"
                autofocus
                required>
              </v-text-field>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    
    <v-flex xs12 class="mt-4">
      <v-form ref="form" v-model="valid" lazy-validation>
        <transition-group name="fade" tag="div">

          <div v-for="questionObj in form" v-bind:key="questionObj.qid">
            <!-- conditional rendering based on type -->
            <Checkbox  v-if="questionObj.type === formTypes.checkbox" :question=questionObj></Checkbox>
            <Textbox   v-else-if="questionObj.type === formTypes.textbox" :question=questionObj></Textbox>
            <SliderBox v-else-if="questionObj.type === formTypes.sliderbox" :question=questionObj></SliderBox>
            <DateBox   v-else-if="questionObj.type === formTypes.datebox" :question=questionObj></DateBox>
            <RatingBox v-else-if="questionObj.type === formTypes.ratingbox" :question=questionObj></RatingBox>
            <TimeBox   v-else-if="questionObj.type === formTypes.timebox" :question=questionObj></TimeBox>
            <RadioBox  v-else-if="questionObj.type === formTypes.radiobox" :question=questionObj></RadioBox>
            <PhotoBox  v-else-if="questionObj.type === formTypes.photobox" :question=questionObj></PhotoBox>
            <NumberBox v-else-if="questionObj.type === formTypes.numberbox" :question=questionObj></NumberBox>
          </div>
          
        </transition-group>
      </v-form>
    </v-flex>
    

    <QuestionTool class="mt-4 pt-1 pb-1"></QuestionTool>

    <transition name="fade">
      <v-btn v-if="form.length > 0" @click="publish" block color="secondary" dark class="mt-4 mb-5">Publish</v-btn>
    </transition>

    <v-dialog
      v-model="showSyncDialog"
      hide-overlay
      persistent
      width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="errorSnackbar" color="error" :timeout="5000" :vertical="true">
      Please, no empty rows :)
      <v-btn dark flat @click="errorSnackbar = false">Close</v-btn>
    </v-snackbar>

  </v-container>
</template>

<script>
  import QuestionTool from '@/components/QuestionTool.vue'
  import Checkbox from '@/components/questionForms/Checkbox.vue'
  import Textbox from '@/components/questionForms/Textbox.vue'
  import SliderBox from '@/components/questionForms/SliderBox.vue'
  import DateBox from '@/components/questionForms/DateBox.vue'
  import RatingBox from '@/components/questionForms/RatingBox.vue'
  import TimeBox from '@/components/questionForms/TimeBox.vue'
  import RadioBox from '@/components/questionForms/RadioBox.vue'
  import PhotoBox from '@/components/questionForms/PhotoBox.vue'
  import NumberBox from '@/components/questionForms/NumberBox.vue'

  export default {
    components: {
      QuestionTool,
      Checkbox,
      Textbox,
      SliderBox,
      DateBox,
      RatingBox,
      TimeBox,
      RadioBox,
      PhotoBox,
      NumberBox
    },
    data: () => ({
      showSyncDialog : false,
      formTitle: null,
      valid: true,
      errorSnackbar : false,
      rules: {
        required: value => !!value || 'Cannot Be Empty.'
      },
      userObj: null,
      isEditMode: false,
      existingOwners: [],
      createdAt: null,
      // Start wathcing for changes and auto-save
      startWatching: false,
      headerImage: null
    }),
    computed: {
      formId() {
        if (this.$route.params.formId){
          
          return this.$route.params.formId;
        }
        return "f_" + this.$uuid.v1().replace(/-/g, "");
      },
      form() {
        return this.$store.state.form;
      }
    },
    watch: {
      form() {
        if (this.startWatching 
          && this.$store.state.form.length > 0 
          && this.formTitle !== null 
          && this.formTitle !== "") {
          // Save to Firebase
          this.save();
        }
      }
    },
    created() {
      // Reset form cache if it's a new form creation
      if (!this.$route.params.formId){
        this.$store.commit('setForm', []);
      }

      this.createdAt = (new Date()).toISOString();

      firebase.auth()
      .onAuthStateChanged((user)=> {
        if (user) {
          // User is signed in.
          this.userObj = user;
          
          // If $route has formId, then this is edit.
          // Fetch the data from server
          if (this.$route.params.formId) {
            this.isEditMode = true;
            this.showSyncDialog = true;
            this.fetch((err)=> {
              if (err) {
                alert(err);
              }
              this.showSyncDialog = false;
            });  
          }
          
        } else {
          this.userObj = null;
          // Not authenticated. Permission error.
          // alert("You musted be logged into edit this form.")
          return;
        }
      });


    },
    mounted() {

    },
    methods: {
      onSubmitPrevent(e) {
      },
      publish() {
        if (!this.$refs.form.validate() || !this.$refs.title.validate()) {
          this.errorSnackbar = true;
          return;
        }
        // console.log(this.$store.state.form)
        // Prompt saving dialog
        this.showSyncDialog = true;
        this.save((err, docRef)=>{
          this.showSyncDialog = false;
          this.$router.push({ path: `/create/${this.formId}` });
          this.$router.push({ path: `/view/${this.formId}` });
        });
      },

      save(cb) {
        console.log("Saving");
        var db = firebase.firestore();

        var savingObj = {
          title: this.formTitle,
          data: this.$store.state.form,
          createdAt: this.createdAt,
          updatedAt: (new Date()).toISOString(),
          owners: this.getOwners()
        };

        if (this.headerImage) {
          savingObj.headerImage = this.headerImage;
        }

        db.collection("forms").doc(this.formId).set(savingObj)
        .then((docRef)=> {
          // console.log("Document written with ID: ", docRef.id);
          if (cb) cb(null, docRef);
        })
        .catch((error)=> {
          console.error("Error adding document: ", error);
          if (cb) cb(error);
        });
      },

      fetch(cb) {

        var db = firebase.firestore();
        const formId = this.$route.params.formId;

        db.collection("forms").doc(formId).get()
        .then((doc)=> {
          

          if (doc.data().owners.includes(this.userObj.uid)) {

            // console.log("Document data:", doc.data());
            this.createdAt = doc.data().createdAt;

            if(doc.data().owners) {
              this.existingOwners = doc.data().owners;
            }

            this.$store.commit('setForm', doc.data().data);
            this.formTitle = doc.data().title;

            // Cache premium features
            this.headerImage = doc.data().headerImage;


            if (cb) cb();  

            // Enable auto-save after 3 seconds to avoid redundant saving on form load
            setTimeout(function(){ this.startWatching = true }, 3000);
          } else {
            if (cb) cb("Permission Error, you are not the owner of this form.");
          }

        })
        .catch((error)=> {
          console.error("Error getting document:", error);
          if (cb) cb(error);
        });

      },

      getOwners() {
        if (this.existingOwners.length > 0) return this.existingOwners;
        if (this.userObj) return [this.userObj.uid];
        return null;
      }
    }
  }
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
